// import breakpoints from css
window.breakpoint = {};
window.breakpoint.refreshValue = function () {
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
	// console.log(this.value);
};

// // http://youmightnotneedjquery.com/
// function hasClass(el, className) {
// 	if (el.classList) {
// 		return el.classList.contains(className);
// 	} else {
// 		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
// 	}
// }

// // http://youmightnotneedjquery.com/
// function toggleClass(el, className) {
// 	if (el.classList) {
// 		el.classList.toggle(className);
// 	} else {
// 		let classes = el.className.split(' ');
// 		let existingIndex = -1;

// 		for (let i = classes.length; i--;) {
// 			if (classes[i] === className) {
// 				existingIndex = i;
// 			}
// 		}

// 		if (existingIndex >= 0) {
// 			classes.splice(existingIndex, 1);
// 		} else {
// 			classes.push(className);
// 		}

// 		el.className = classes.join(' ');
// 	}
// }